import React from 'react';
import styled, { keyframes } from 'styled-components';

const spinner = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  height: ${props => props.fullheight ? '100vh' : 'auto'};
`;

const LoaderSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: ${spinner} 1s linear infinite;
`;

const Loader = ({ fullHeight = false }) => {
  return (
    <LoaderContainer fullHeight={fullHeight}>
      <LoaderSpinner />
    </LoaderContainer>
  );
};

export default Loader;